import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package, Check } from "lucide-react";
import LandingShell from "../components/LandingShell";
import Btn from "../components/Btn";
import api from "../lib/api";
import { PromoCountdown } from "../components/PromoCountdown";

const perLabel = (p) => {
  const d = p.grant?.vip_days || 0;
  if (d >= 360) return "/tahun";
  if (d === 30) return "/bulan";
  if (d) return `/${Math.round(d / 30)} bln`;
  return "";
};

export default function Paket() {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products").then(({ data }) => setProducts(data.products)).catch(() => {}); }, []);

  const typeRank = (t) => (t === "tryout_pack" ? 0 : t === "subscription" ? 1 : 2);
  const ordered = [...products].sort((a, b) => typeRank(a.type) - typeRank(b.type) || (a.order || 99) - (b.order || 99));

  return (
    <LandingShell wide title="Paket & Harga" icon={Package}
      subtitle="Mulai gratis selamanya, upgrade kapan saja untuk membuka seluruh potensimu.">
      <div className="grid md:grid-cols-3 gap-5 max-w-5xl mx-auto" data-testid="paket-page">
        <div className="card-chunky p-6 flex flex-col" data-testid="paket-freemium">
          <h3 className="font-heading font-black text-xl">Freemium</h3>
          <div className="my-3"><span className="font-heading font-black text-3xl">Rp0</span><span className="text-su-muted font-bold text-sm">/selamanya</span></div>
          <ul className="space-y-2 text-sm font-medium text-su-muted flex-1 mb-5">
            {["5 token awal + energi 100", "Tryout, Drill & Arena", "Leaderboard nasional", "Modul materi — terkunci 🔒", "AI Mentor — terkunci 🔒"].map((x) => (
              <li key={x} className="flex items-start gap-2"><Check className="w-4 h-4 text-su-success shrink-0 mt-0.5" />{x}</li>
            ))}
          </ul>
          <Link to="/auth"><Btn variant="ghost" className="w-full">Mulai Gratis</Btn></Link>
        </div>

        {ordered.map((p) => {
          const isVip = p.type === "subscription";
          const isPack = p.type === "tryout_pack";
          return (
            <div key={p.product_id} className={`card-chunky p-6 flex flex-col ${isPack ? "ring-4 ring-su-primary/30 relative" : isVip ? "ring-4 ring-su-secondary/30 relative" : ""}`} data-testid={`paket-${p.product_id}`}>
              {p.discount_label ? <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-su-secondary text-black text-xs font-heading font-black px-3 py-1 rounded-full">{p.discount_label}</span>
                : isPack ? <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-su-primary text-white text-xs font-heading font-black px-3 py-1 rounded-full">TANPA TOKEN</span>
                : isVip && <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-su-primary text-white text-xs font-heading font-black px-3 py-1 rounded-full">TERPOPULER</span>}
              <h3 className="font-heading font-black text-xl">{p.name}</h3>
              <div className="my-3 flex items-baseline gap-2 flex-wrap">{p.original_amount > p.amount && <span className="font-heading font-bold text-lg text-su-muted line-through">Rp{Number(p.original_amount).toLocaleString("id-ID")}</span>}<span className="font-heading font-black text-3xl">Rp{Number(p.amount).toLocaleString("id-ID")}</span><span className="text-su-muted font-bold text-sm">{isVip ? perLabel(p) : ""}</span></div>
              {p.original_amount > p.amount && p.promo_ends_at && <div className="-mt-1 mb-2"><PromoCountdown endsAt={p.promo_ends_at} testId={`promo-countdown-${p.product_id}`} /></div>}
              <ul className="space-y-2 text-sm font-medium text-su-muted flex-1 mb-5">
                {(p.features?.length ? p.features : [
                  p.grant?.tokens ? `${p.grant.tokens} token` : null,
                  p.grant?.energy ? `Energi ${p.grant.energy}` : null,
                ].filter(Boolean)).map((x) => <li key={x} className="flex items-start gap-2"><Check className="w-4 h-4 text-su-success shrink-0 mt-0.5" />{x}</li>)}
              </ul>
              <Link to="/auth"><Btn variant={isVip || isPack ? "primary" : "ghost"} className="w-full">{isVip ? "Jadi VIP" : isPack ? "Beli Paket" : "Beli Token"}</Btn></Link>
            </div>
          );
        })}
      </div>
      <p className="text-center text-su-muted font-medium text-sm mt-8">Pembayaran aman. Butuh bantuan memilih paket? <Link to="/contact" className="text-su-primary font-heading font-bold">Hubungi kami</Link>.</p>
    </LandingShell>
  );
}
